/**
 * Crew validation utilities
 * Phase 7: Validation & Edge Cases
 */

/**
 * Check if crew member with similar name already exists
 * @param {string} name - Crew member name to check
 * @param {Array} existingCrew - Current crew list
 * @param {string} excludeId - Optional ID to exclude (for edit mode)
 * @returns {Object|null} - Duplicate crew object if found, null otherwise
 */
export const findDuplicateCrew = (name, existingCrew, excludeId = null) => {
  if (!name || !existingCrew) return null;

  const normalizedName = name.trim().toLowerCase();

  return existingCrew.find(crew => {
    // Skip if this is the same crew member (edit mode)
    if (excludeId && crew.id === excludeId) return false;

    // Skip archived crew
    if (crew.status === 'archived') return false;

    // Compare normalized names
    const crewName = (crew.full_name || crew.name || '').trim().toLowerCase();
    return crewName === normalizedName;
  });
};

/**
 * Validate email format
 * @param {string} email - Email address to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const validateEmail = (email) => {
  if (!email) return true; // Email is optional

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};
